import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import { CtaWhatsApp } from "../components/Cta";
import CardMockup, { CardPair } from "../components/CardMockup";
import { Tilt } from "../components/motion";

export default function NotFound() {
  return (
    <>
      <Seo
        title="Page introuvable"
        description="La page que vous cherchez n'existe pas ou a été déplacée."
        path="/404"
      />
      <section className="grain relative flex min-h-screen items-center overflow-hidden bg-nuit-900 py-24 text-white">
        <div
          className="pointer-events-none absolute inset-0"
          style={{ background: "radial-gradient(50% 45% at 50% 20%, rgba(22,119,255,0.25) 0%, transparent 70%)" }}
          aria-hidden="true"
        />
        <div className="container-nv relative grid items-center gap-12 lg:grid-cols-2">
          <div>
            <p className="eyebrow text-electric-300">Erreur 404</p>
            <h1 className="mt-4 font-display text-5xl font-bold tracking-tight sm:text-7xl">
              Ce geste n'ouvre
              <br />
              aucun monde.
            </h1>
            <p className="mt-6 max-w-md text-white/70 sm:text-lg">
              La page que vous cherchez n'existe pas ou a été déplacée. Revenons à l'essentiel.
            </p>
            <div className="mt-9 flex flex-wrap items-center gap-5">
              <Link
                to="/"
                data-testid="notfound-home-btn"
                className="inline-flex items-center justify-center rounded-full bg-white px-7 py-3.5 font-display font-semibold text-nuit-900 transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-brume-200"
              >
                Retour à l'accueil
              </Link>
              <CtaWhatsApp
                label="Nous contacter sur WhatsApp"
                variant="outlineLight"
                testid="notfound-cta-whatsapp"
              />
            </div>
          </div>
          <div className="hidden justify-center lg:flex">
            <Tilt max={14}>
              <div className="w-[30rem] rotate-[-4deg] opacity-90">
                <CardPair name="Noveocard" slogan="Un simple geste ouvre un monde" />
              </div>
            </Tilt>
          </div>
        </div>
      </section>
    </>
  );
}
